import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
  name: 'msk',
})
export class MskPipe implements PipeTransform {
  private readonly _tail = `МСК`;
  private readonly _currentYearMask = 'DD MMMM, HH:mm';
  private readonly _notCurrentYearMask = 'DD MMMM YYYY, HH:mm';

  constructor() {
    moment.locale('ru');
  }

  transform(utcDate: any, mask: string = '', isMsk: boolean = true, prefix: string = ''): any {
    const date = moment.utc(utcDate).tz('Europe/Moscow');
    const mskTail = isMsk ? this._tail : '';
    const isSameYear = date.year() === moment().year();
    const format = mask ? mask : isSameYear ? this._currentYearMask : this._notCurrentYearMask;

    return `${prefix} ${date.format(format)} ${mskTail}`;
  }
}
